import React from 'react';
import JsonLd from './JsonLd';

/**
 * BreadcrumbList Schema - tells Google the navigation hierarchy.
 * Helps render breadcrumb rich results below the page title in SERP.
 *
 * @param {Array<{name: string, url: string}>} items - Breadcrumb trail (Home → Section → Page)
 */
const BreadcrumbSchema = ({ items }) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return <JsonLd data={schema} />;
};

export default BreadcrumbSchema;
